import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  DialogTitle,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TextField,
  Grid,
  IconButton
} from "@mui/material";
import { UrlApiEnvasado } from "../../../services/apirest";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Icono de retroceso
import { grey } from "@mui/material/colors";
import moment from "moment";
import MaterialReactTable, {
    MRT_FullScreenToggleButton,
  } from "material-react-table";
  import { MRT_Localization_ES } from "material-react-table/locales/es";
import DetalleFactura from "../DetalleFactura";

function VistaFacturasChofer(props) {
    const [facturas, setFacturas] = useState()
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${UrlApiEnvasado}api/estadistica/xchofer/deudores/${props.fechaDesde}/${props.fechaHasta}/${props.chofer}`)
      .then((res) => res.json())
      .then((data) => {
        setFacturas(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al obtener clientes:", error);
        setLoading(false);
      });
  }, []);

    const handleClose = () => {
        props.setOpen(false);
      };

          const columns = useMemo(
            () => [
                {
                    accessorKey: "descripcion", //access nested data with dot notation
                    header: "Tipo",
                    maxSize: 40,
                  },
                  {
                    accessorKey: "name_sucursal", //access nested data with dot notation
                    header: "Sucursal",
                    size: 115,
                  },
                  {
                    accessorKey: "name_cliente", //access nested data with dot notation
                    header: "Facturado a",
                    size: 115,
                  },
                  {
                    accessorKey: "name_cliente_adi", //access nested data with dot notation
                    header: "Cliente",
                    size: 115,
                  },
                  {
                    accessorKey: "ccd_fecha_mov", //access nested data with dot notation
                    header: "Fecha",
                    size: 115,
                  },
                  {
                    accessorKey: "ccd_total", //access nested data with dot notation
                    header: "Importe Total",
                    size: 115,
                  },
            ],
            []
          );
          const customLocalization = {
            ...MRT_Localization_ES,
            expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
            expand: "Ex", // Cambia 'Expandir' a 'Ex'
          };
      
          const muiSearchTextFieldProps = {
              placeholder: "Buscar..",
              sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
              variant: "outlined",
              color: "primary",
              size: "small",
            };
            
            const tableHeadCellProps = {
              align: "left",
              sx: {
                fontSize: 16,
                color: "white",
                fontWeight: "normal",
                backgroundColor: "#2471A3",
                borderColor: "black",
              },
            };
          
            const initialState = {
              //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
              density: "compact",
              showGlobalFilter: true,
              pagination: { pageIndex: 0, pageSize: 10 },
            };
  return (
    <Dialog fullWidth open={props.open} onClose={handleClose} maxWidth="xl">
      <Box justifyContent="center" backgroundColor="#1F618D">
      <Grid container backgroundColor="#1F618D" p={1}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>
            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
          <Typography fontSize={20} align="center" color="#ffffff">
            Facturas de {props.nombre} -- {moment(props.fechaDesde, "YYYY-MM-DD").format("DD/MM/YYYY")} - {moment(props.fechaHasta, "YYYY-MM-DD").format("DD/MM/YYYY")}
          </Typography>
          </Grid>
          </Grid>
      </Box>
      <DialogContent>
      {loading ? (
                <Box display="flex" justifyContent="center" p={2}>
                  <CircularProgress />
                </Box>
              ) : (
                <Box mt={0} mb={4}>
            <MaterialReactTable
              columns={columns}
              data={facturas ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false} //deshabilita las acciones POR COLUMN}
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableGrouping={true}
              enablePinning={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
            //   enableEditing
              localization={customLocalization}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              renderDetailPanel={({ row }) => (
                <DetalleFactura row={row.original} />
              )}
              // muiTableBodyRowProps={({ row }) => ({
              //   sx: {
              //     backgroundColor: row.original.estado === 272
              //       ? null
              //       : row.original.estado === 273
              //       ? "#ffff88"
              //       : row.original.estado === 274
              //       ? "#acec98"
              //       : null,
              //   },
              // })}
              // muiTableDetailPanelProps={{
              //   sx: {
              //     backgroundColor: 'white', // Fondo blanco para el panel de detalles
              //     width: '100%', 
              //   },
              // }}
              enableColumnResizing={true}
              // renderDetailPanel={({ row }) => <Pedidos_rendicion row={row.original} />}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
              })}
              renderTopToolbarCustomActions={() => (
                <div style={{alignContent:"center"}}>
                  <Typography variant="poster" fontSize={26}>
                  </Typography>
                </div>
              )}
            />
            </Box>
          )}
      </DialogContent>
    </Dialog>
  )
}

export default VistaFacturasChofer